import React from 'react';

import ButtonWithPopover from './ButtonWithPopover';

import Button from 'react-bootstrap/Button';

const RmPopoverButton = (props) => {

  const callbackFunction = () => {
    props.callbackFunction();
  }

  return (
    <ButtonWithPopover
      placement="top"
      buttonVariant={props.btnVariant || "info"}
      buttonText={props.btnText}
      buttonIsBlock={true}
      buttonIsDisabled={props.disallowEditing}
      buttonId={`${props.btnText}-popover`}
      buttonClassName={props.btnClassName}
      dataTestId={props.dataTestId}
    >
      <p className="confirmation-text">
        {props.confirmationText}
      </p>
      <div className="align-content-right">
        <Button className="left-spacer" variant={props.btnVariant || "info"}
          onClick={() => callbackFunction()} id={`${props.btnText}-callback-function`}>
          {props.btnText}
        </Button>
      </div>
    </ButtonWithPopover>
  );
}

export default RmPopoverButton;
